import React, { PropsWithChildren, ReactElement, FC } from 'react';

interface HelpBlockProps {
    variant?: TextVariant;
}
const HelpBlock: FC<PropsWithChildren<HelpBlockProps>> = ({
	children,
	variant,
}: PropsWithChildren<HelpBlockProps>): ReactElement => (
	<div className={`help-block${variant ? ' text-' + variant : ' '}`}>{children}</div>
);
export default HelpBlock;
